export default __webpack_public_path__ + "static/media/num-icon1.5bf44c48.svg";